import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from 'src/utils/api';
import { IRAAutoMaxFundsActionTypes as act } from './actionTypes';

export default function iraAutoMaxFunds(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    error: null,
    funds: [],
  },
  { payload, type }
) {
  switch (type) {
    case act.IRA_AUTO_MAX_FUNDS_PENDING:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };
    case act.IRA_AUTO_MAX_FUNDS_FULFILLED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        funds: payload.body ? payload.body : [],
      };

    case act.IRA_AUTO_MAX_FUNDS_REJECTED:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        funds: [],
        error: payload,
      };
    default:
      return state;
  }
}

export const getIRAAutoMaxFunds = () => {
  return () => {
    const iraAutoMaxSelectionEndpoint = getEndpoint('iraAutoMaxSelection');
    return createAction(act.IRA_AUTO_MAX_FUNDS)(
      callApi(`${iraAutoMaxSelectionEndpoint}`)
    );
  };
};
